export default "__VITE_ASSET__BoPveMAz__"